'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Heading = require('../Heading');

var _Heading2 = _interopRequireDefault(_Heading);

var _sizes = require('HubStyleTokens/sizes');

var _misc = require('HubStyleTokens/misc');

var _Styles = require('../../utils/Styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var H4 = (0, _styledComponents2.default)(_Heading2.default).withConfig({
  displayName: 'H4'
})(['', ';', ';'], _Styles.FONT_FAMILIES[_misc.HEADING_WEIGHT4], (0, _Styles.setFontSize)(_sizes.HEADING4));

H4.propTypes = _extends({}, _Heading2.default.propTypes);

H4.defaultProps = _extends({}, _Heading2.default.defaultProps, { tagName: 'h4' });

H4.displayName = 'H4';

exports.default = H4;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/elements/headings/H4.js
// module id = 318
// module chunks = 3 4 5